import ReactDOM from 'react-dom';
import React, { Component } from 'react';
import { Router, Route, Switch } from 'react-router-dom';

import SecurityDisclaimerPage from "./components/leadInfo/securityDisclaimer";
import ReleaseNotesPage from "./components/leadInfo/releaseNotes";
import { InitJsStore } from "./offline/storageService/idbService";
import { CheckOnline, CheckPageRefresh } from './offline/dataService/offlineSyncData'

import { history } from './apiAuthorization/history';
import { authenticationService } from './apiAuthorization/authenticationService';
import LoginPage from './components/login/login';
import registerServiceWorker from './registerServiceWorker';
import { PrivateRoute } from './apiAuthorization/privateRoute';
import Home from "./components/home/home";
import JournalList from "./components/journal/journalList";
import SafetyCoachingList from "./components/safetyCoaching/safetyCoachingList";
import VisitationLogList from "./components/visitationLog/visitationLogList";
import SafetyCoachingAdd from "./components/safetyCoaching/safetyCoachingAdd";
import JournalAdd from "./components/journal/journalAdd";
import StaffingList from "./components/staffing/staffingList";
import ServiceRecoveryList from "./components/serviceRecovery/serviceRecoveryList";
import User from "./components/settings/user/user"
import "../src/css/material-dashboard-react.css?v=1.8.0";
import { SiteContext } from './components/contexts/siteContext';
import { ThemeContext } from './components/contexts/themeContext';
import { StreakContext } from './components/contexts/streakContext';
import './css/site.css';
import TeamProList from './components/teamPro/teamProList';
import { MainLayout } from './layouts/mainLayout';
import { OfflineContext } from './components/contexts/offlineContext';
import { WeatherContext } from './components/contexts/weatherContext';
import { UserContext } from './components/contexts/userContext';
import { ModuleContext } from './components/contexts/modulesContext';
import { ServiceRecoveryContext } from './components/contexts/serviceRecoveryContext';
import { AssignedToUsersContext } from './components/contexts/assignedToUsers';
import { AppSettingMenuContext } from './components/contexts/appSettingMenuContext';
import { SystemVariableContext } from './components/contexts/systemVariableContext';
import { TeamProContext } from './components/contexts/teamProContext';
import RoundsList from './components/round/roundsList';
import { ResolutionCommentContext } from './components/contexts/resolutionCommentContext';
import { SafetyCoachingContext } from './components/contexts/safetyCoachingContext';
import VisitationEVSList from './components/visitationEVS/visitationEVSList';
import VisitationEVSAdd from './components/visitationEVS/visitationEVSAdd';
import RecoveryEVSList from './components/recoveryEVS/recoveryEVSList';
import PatientSittingList from "./components/patientSitting/patientSittingList";
import PatientSittingAdd from "./components/patientSitting/patientSittingAdd";
import PatientStatusAdd from "./components/patientSitting/patientStatusAdd";
import ObservationDashboard from "./components/patientSitting/observationDashboard";
import RDOAccountVisitationList from "./components/rdoAccountVisitation/rdoAccountVisitationList";
import RDOAccountVisitationAdd from "./components/rdoAccountVisitation/rdoAccountVisitationAdd";
import RDODirectorActionAdd from "./components/rdoAccountVisitation/directorActionAdd";
import SystemVariableList from "./components/settings/systemVariable/systemVariableList";
import SystemVariableAdd from "./components/settings/systemVariable/systemVariableAdd";
import UnitAdd from "./components/settings/unit/unitAdd";
import UnitList from "./components/settings/unit/unitList";
import UnitLocation from "./components/settings/unit/unitLocation";
import UnitLocationAdd from "./components/settings/unit/unitLocationAdd";
import RoundListAdd from "./components/settings/roundList/roundListAdd";
import RoundList from "./components/settings/roundList/roundList";
import RoundListLocation from "./components/settings/roundList/roundListLocation";
import RoundListLocationAdd from "./components/settings/roundList/roundListLocationAdd";
import Geography from "./components/settings/geography/geography";
import UserGroupAdd from "./components/settings/userGroup/userGroupAdd";
import UserGroupList from "./components/settings/userGroup/userGroupList";
import UerGroupModule from "./components/settings/userGroup/userGroupModule";
import UserGroupSetting from "./components/settings/userGroup/userGroupSetting";
import UserGroupUserAdd from "./components/settings/userGroup/userGroupUserAdd";
import UserGroupUserList from "./components/settings/userGroup/userGroupUserList";
import InactiveTimeout from './components/common/inactiveTimeout';
import UserList from "./components/settings/user/userList";
import TeamCoachList from './components/teamCoach/teamCoachAdd';
import HuddleList from './components/huddle/huddleList';
import JournalReport from './components/reports/journalReport';
import RoundReport from './components/reports/roundReport';
import VisitationEVSReport from './components/reports/visitationEVSReport';
import RecoveryEVSReport from './components/reports/recoveryEVSReport';
import POSObservationLogReport from './components/reports/posObservationLogReport';
import POSSignoffLogReport from './components/reports/posSignoffLogReport';
import POSOverallUsageReport from './components/reports/posOverallUsageReport';
import POSUnitBreakoutReport from './components/reports/posUnitBreakoutReport';
import POAHoursLogReport from './components/reports/poaHoursLogReport';
import POSOtherDutiesReport from './components/reports/posOtherDutiesReport';
import POSPersonnelTransactionsReport from './components/reports/posPersonnelTransactionsReport';
import POSMultipleAssignmentsReport from './components/reports/posMultipleAssignmentsReport';
import POSAttendantChecklistAcceptanceReport from './components/reports/posAttendantChecklistAcceptanceReport';
import SafetyCoachingReport from './components/reports/safetyCoachingReport';
import Dashboard from './components/reports/dashboard';
import ModuleOrder from './components/userSettings/moduleOrder';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href')
const rootElement = document.getElementById('root');
CheckPageRefresh();

class App extends Component {

    constructor(props) {
        super(props);

        this.state = {
            currentUser: null
        };
    }

    componentDidMount() {
        authenticationService.currentUser.subscribe(x => this.setState({ currentUser: x }));
    }

    render() {
        return (
            <Router basename={baseUrl} history={history}>
                <div>
                    <Switch>
                        <ThemeContext>
                            <Route path="/login" component={LoginPage} />
                            <Route path="/SecurityDisclaimer" component={SecurityDisclaimerPage} />
                            <Route path="/ReleaseNotes" component={ReleaseNotesPage} />
                            <SiteContext>
                                <ModuleContext>
                                    <UserContext>
                                        <OfflineContext>
                                            <PrivateRoute exact path="/home" component={Home} />
                                            <PrivateRoute path="/ModuleOrder" component={ModuleOrder} />
                                            <PrivateRoute path="/SystemVariableAdd" component={SystemVariableAdd} />
                                            <PrivateRoute path="/SystemVariableList" component={SystemVariableList} />
                                            <PrivateRoute path="/UnitAdd" component={UnitAdd} />
                                            <PrivateRoute path="/UnitList" component={UnitList} />
                                            <PrivateRoute path="/UnitLocation" component={UnitLocation} />
                                            <PrivateRoute path="/UnitLocationAdd" component={UnitLocationAdd} />
                                            <PrivateRoute path="/RoundListAdd" component={RoundListAdd} />
                                            <PrivateRoute path="/RoundList" component={RoundList} />
                                            <PrivateRoute path="/RoundListLocation" component={RoundListLocation} />
                                            <PrivateRoute path="/RoundListLocationAdd" component={RoundListLocationAdd} />
                                            <PrivateRoute path="/UserGroupAdd" component={UserGroupAdd} />
                                            <PrivateRoute path="/UserGroupList" component={UserGroupList} />
                                            <PrivateRoute path="/UerGroupModule" component={UerGroupModule} />
                                            <PrivateRoute path="/UserGroupSetting" component={UserGroupSetting} />
                                            <PrivateRoute path="/UserGroupUserAdd" component={UserGroupUserAdd} />
                                            <PrivateRoute path="/UserGroupUserList" component={UserGroupUserList} />
                                            <PrivateRoute path="/Geography" component={Geography} />
                                            <PrivateRoute path="/UserList" component={UserList} />
                                            <PrivateRoute path="/StaffingList" component={StaffingList} />
                                            <SystemVariableContext>
                                                <SafetyCoachingContext>
                                                    <PrivateRoute path="/SafetyCoachingList" component={SafetyCoachingList} />
                                                    <PrivateRoute path="/SafetyCoachingAdd" component={SafetyCoachingAdd} />
                                                </SafetyCoachingContext>
                                                <ServiceRecoveryContext>
                                                    <AssignedToUsersContext>
                                                        <PrivateRoute path="/VisitationEVSAdd" component={VisitationEVSAdd} />
                                                        <PrivateRoute path="/VisitationEVSList" component={VisitationEVSList} />
                                                        <PrivateRoute path="/RecoveryEVSList" component={RecoveryEVSList} />
                                                        <TeamProContext>
                                                            <ResolutionCommentContext>
                                                                <PrivateRoute path="/VisitationLogList" component={VisitationLogList} />
                                                                <PrivateRoute path="/ServiceRecoveryList" component={ServiceRecoveryList} />
                                                                <PrivateRoute path="/TeamProList" component={TeamProList} />
                                                                <PrivateRoute path="/Rounds" component={RoundsList} />
                                                            </ResolutionCommentContext>
                                                        </TeamProContext>
                                                    </AssignedToUsersContext>
                                                </ServiceRecoveryContext>
                                                <PrivateRoute path="/User" component={User} />
                                                <PrivateRoute path="/TeamCoachList" component={TeamCoachList} />
                                                <PrivateRoute path="/JournalList" component={JournalList} />
                                                <PrivateRoute path="/JournalAdd" component={JournalAdd} />
                                                <PrivateRoute path="/InactiveTimeout" component={InactiveTimeout} />
                                                <PrivateRoute path="/PatientSittingList" component={PatientSittingList} />
                                                <PrivateRoute path="/PatientSittingAdd" component={PatientSittingAdd} />
                                                <PrivateRoute path="/PatientStatusAdd" component={PatientStatusAdd} />
                                                <PrivateRoute path="/RDOAccountVisitationList" component={RDOAccountVisitationList} />
                                                <PrivateRoute path="/RDOAccountVisitationAdd" component={RDOAccountVisitationAdd} />
                                                <PrivateRoute path="/RDODirectorActionAdd" component={RDODirectorActionAdd} />
                                                <PrivateRoute path="/HuddleList" component={HuddleList} />
                                                <PrivateRoute path="/JournalReport" component={JournalReport} />
                                                <PrivateRoute path="/RoundReport" component={RoundReport} />
                                                <PrivateRoute path="/VisitationEVSReport" component={VisitationEVSReport} />
                                                <PrivateRoute path="/RecoveryEVSReport" component={RecoveryEVSReport} />
                                                <PrivateRoute path="/POSObservationLogReport" component={POSObservationLogReport} />
                                                <PrivateRoute path="/POSSignoffLogReport" component={POSSignoffLogReport} />
                                                <PrivateRoute path="/POSOverallUsageReport" component={POSOverallUsageReport} />
                                                <PrivateRoute path="/POSUnitBreakoutReport" component={POSUnitBreakoutReport} />
                                                <PrivateRoute path="/POAHoursLogReport" component={POAHoursLogReport} />
                                                <PrivateRoute path="/POSOtherDutiesReport" component={POSOtherDutiesReport} />
                                                <PrivateRoute path="/POSPersonnelTransactionsReport" component={POSPersonnelTransactionsReport} />
                                                <PrivateRoute path="/POSMultipleAssignmentsReport" component={POSMultipleAssignmentsReport} />
                                                <PrivateRoute path="/POSAttendantChecklistAcceptanceReport" component={POSAttendantChecklistAcceptanceReport} />
                                                <PrivateRoute path="/SafetyCoachingReport" component={SafetyCoachingReport} />
                                                <PrivateRoute path="/Dashboard" component={Dashboard} />
                                                <PrivateRoute path="/ObservationDashboard" component={ObservationDashboard} />
                                                <StreakContext>
                                                    <AppSettingMenuContext>
                                                        <WeatherContext>
                                                            <PrivateRoute path="/" component={MainLayout} exact />
                                                        </WeatherContext>
                                                    </AppSettingMenuContext>
                                                </StreakContext>
                                            </SystemVariableContext>
                                        </OfflineContext>
                                    </UserContext>
                                </ModuleContext>
                            </SiteContext>
                        </ThemeContext>
                    </Switch>
                </div>
            </Router>
        );
    }
}

ReactDOM.render(<App />, rootElement);
registerServiceWorker();
InitJsStore();
CheckOnline();
